import { Chip, Collapse, Divider, Stack } from "@mui/material";
import { useFiltersReturn } from "../hooks/use-filters";
import FilterChip from "./filter-chips";

interface FilterChipContainerProps {
    filterData: useFiltersReturn
}

export default function FilterChipContainer({
    filterData
}: FilterChipContainerProps) {
    const activeFilters = filterData.filters.filter(filter => filter.type !== "pagination" && filter.active);

    return <Collapse in={activeFilters.length > 0}>
        <Stack gap={2} marginBottom={2}>
            <Divider flexItem />
            <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
                {activeFilters.map(filter => <FilterChip key={filter.key} filter={filter} filterData={filterData} />)}
                <Chip label={""} size="small" sx={{ visibility: "hidden" }} />
            </Stack>
        </Stack>
    </Collapse>
}
